import { Paper, Skeleton, Stack, Box } from '@mui/material';

export const InvoicesHighlightsSkeleton: React.FC = () => (
  <Paper
    elevation={0}
    sx={{
      borderRadius: '12px',
      p: 3,
      mb: 2,
      backgroundColor: '#FAFBFF',
      border: '1px solid #CFE6FF',
      height: '92px',
    }}
  >
    <Stack direction="row" spacing={1}>
      {Array.from({ length: 4 }).map((_, index) => (
        <Box key={index} sx={{
          px: 3
        }}>
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              mb: 0.25
            }}>
            <Skeleton
              variant="text"
              width={139}
              height={18}
              sx={{ borderRadius: '6px', background: '#D8E8FF' }}
            />
          </Stack>
          <Stack direction="row" sx={{
            alignItems: "baseline"
          }}>
            <Skeleton
              variant="text"
              width={73}
              height={18}
              sx={{ borderRadius: '6px', background: '#D8E8FF' }}
            />
          </Stack>
        </Box>
      ))}
    </Stack>
  </Paper>
);
